import userEventBase from '@testing-library/user-event'

import * as userEventExtensions from './userEventExtensions'

const userEvent = { ...userEventBase, ...userEventExtensions }

export default userEvent
